import styled from 'styled-components';

export const Content = styled.div`
  width: 25px;
  height: 25px;
  display: flex;
  justify-content: center;
  align-items: center;
  background-color: #262a2e;
  margin-right: 20px;
  border-radius: 50%;
  cursor: pointer;
  &.sm {
    width: 22px;
    height: 22px;
  }
`;

export const IndicatorActive = styled.div`
  width: 13px;
  height: 13px;
  border-radius: 50%;
  background-color: #47a9fe;
  &.sm {
    width: 12px;
    height: 12px;
  }
`;
